import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { MessageRendererService } from 'src/app/services/message-renderer.service';
import { ParametroEmpresaService } from "src/app/services/parametro-empresa.service";
import { StorageVariable } from '../shared/object/local-storage-variable.enum';

@Injectable({
  providedIn: 'root'
})
export class DescargarArchivoService {
  private apiUrl: string = '';
  private produccion: boolean = true;
  constructor(private http: HttpClient,
    private parametroEmpresaService: ParametroEmpresaService,
    private messageRendererService: MessageRendererService) { }

  descargarArchivo(nombreArchivoLocal: string): Observable<Blob> {
    return new Observable<Blob>((observer) => {
      this.parametroEmpresaService.obtenerUrlDescagarBlob(this.getRutEmpresa(), ({ respuesta, mensajes }) => {
        if (mensajes && mensajes.length > 0) {
          this.messageRendererService.showErrors(mensajes);
          observer.error('Error al obtener la URL del negociador');
          return;
        }
        const url_blob = respuesta.valor;
        if (this.produccion) {
          this.apiUrl = url_blob;
         } else {
          this.apiUrl = 'http://localhost:7071/api/DescargarArchivoDesdeBlob'
        }
        const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
        const params = {
          nombreArchivoLocal: nombreArchivoLocal
        };
        this.http.get(this.apiUrl, { params: params, headers: headers, responseType: 'blob' as 'json' })
          .subscribe(
            (data: Blob) => {
              observer.next(data); // Emitir los datos del archivo descargado
              observer.complete(); // Completar el observable
            },
            (error) => {
              console.error('Error al descargar el archivo:', error);
              observer.error(error); // Emitir un error si la descarga falla
            }
          );
      });
    });
  }

  getRutEmpresa(): any {
    return localStorage.getItem(StorageVariable.RUT_EMPRESA);
  }
}
